// eslint-disable-next-line no-restricted-modules
const $ = require('jquery');
const { addCookiePlugin } = require('./jquery.cookie');
const { addAutosizePlugin } = require('./jquery.autosize');
const { throttleOnAnimationFrame } = require('@trello/time');

$.extend({ throttleOnAnimationFrame });

addCookiePlugin($);
addAutosizePlugin($);

window.jQuery = $;
window.$ = $;

require('../vendor/jquery.ui/widget');
require('../vendor/jquery.ui/widgets/mouse');
require('../vendor/jquery.ui/core');
require('../vendor/jquery.ui/position');
require('../vendor/jquery.ui/widgets/draggable');
require('../vendor/jquery.ui/widgets/droppable');
require('../vendor/jquery.ui/widgets/sortable');

// Apparently those stupid files don't close over the jQuery variable.
// So we can't delete it after we're done.
// delete window.jQuery;
// delete window.$;

module.exports = $;
